import * as Sentry from '@sentry/browser'
import { SET_MAP_CENTER, SET_ZIPCODE, SET_ZIP_VISIBLE, SORT_ZIP_EXPLORE, SET_FILTER_QUERY } from './actionTypes'
import { QUESTION_ACKNOWLEDGED_MARKET_TEMP } from '../constants/zip_modal'
import { saveClientAnswer } from './client'

export const sortZipExplore = sort => ({
  type: SORT_ZIP_EXPLORE,
  sort
})

export const setZipCode = zipcode => ({
  type: SET_ZIPCODE,
  zipcode
})

export const setZipVisible = visibleZips => ({
  type: SET_ZIP_VISIBLE,
  visibleZips
})

export const setMapCenter = ({ center, zoom }) => ({
  type: SET_MAP_CENTER,
  mapCenter: { center, zoom }
})

export const setFilterQuery = filterQuery => ({
  type: SET_FILTER_QUERY,
  filterQuery
})

export const clearFilterQuery = () => dispatch => dispatch(setFilterQuery(null))

export const handleAcknowledgeMarketTemp = () => async dispatch => {
  try {
    dispatch(
      saveClientAnswer({
        question: QUESTION_ACKNOWLEDGED_MARKET_TEMP,
        response: {
          value: true
        }
      })
    )
  } catch (error) {
    // We don't really care too much if this fails, but let's log to Sentry at least
    Sentry.captureException(error)
  }
}
